import React from 'react';

import { Container, Row, Col } from "reactstrap";

import { Construction } from "../../components";

class Socials extends React.Component {
  render() {
    return (
      <Container>
        <Construction />
      </Container>
    );
  }
}

export { Socials };

export default Socials;